import React from 'react';
// Image ko import karein
import portfolioImg1 from '../assets/img/portfolio-1.jpg'; 

const Projects = () => {
  const projects = [
    {
      category: 'Shopify',
      title: 'Woodstock Goods',
      image: portfolioImg1, // Yahan variable use karein
      url: 'https://woodstockgoods.com/'
    },
    {
      category: 'Shopify',
      title: 'Vibesdelmundo – Home Décor & Furniture E-Commerce Store',
      image: portfolioImg1,
      url: 'https://vibesdelmundo.com/'
    },
    {
      category: 'WordPress',
      title: 'Couriers3030',
      image: portfolioImg1,
      url: 'https://couriers3030.com.au/'
    },
    {
      category: 'WordPress',
      title: 'Digital Institute of Hongkong',
      image: portfolioImg1,
      url: 'https://digitalinstitute.edu.hk/en/'
    }
  ];

  return (
    <section className="portfolio_work" id="projects">
      <div className="portfolio_project_work" data-aos="fade-up">
        <h2 className="project-heading text-center">My Recent Works</h2>
      </div>
      <div className="portfolio-project-box">
        {projects.map((project, index) => (
          <div key={index} className="work-box-column border-top" data-aos="fade-up">
            <div className="port-category">
              <span className="work-project-title">{project.category}</span>
            </div>
            <div className="port-project-heading">
              <h3><a href={project.url} target='_blank' rel="noreferrer">{project.title}</a></h3>
            </div>
            <div className="port-project-image">
              <img src={project.image} alt={project.title} className="project-image" />
              <div className="port-content text-center">
                <a href={project.url} target='_blank' rel="noreferrer">
                <span className="d-inline-block">
                  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
                    <g fill="#000">
                      <path d="M7.146 7.146a.75.75 0 0 1 1.061 0l8.5 8.5a.75.75 0 1 1-1.06 1.061l-8.5-8.5a.75.75 0 0 1 0-1.06z"></path>
                      <path d="M16.177 6.427a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-9a.75.75 0 0 1 0-1.5h8.25v-8.25a.75.75 0 0 1 .75-.75z"></path>
                    </g>
                  </svg>
                </span>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Projects;
